import * as React from 'react';
function SvgNavigationMenuHorizontal(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentcolor"
      className="navigation-menu-horizontal_svg__fil-icon"
      {...props}
    >
      <circle cx={3.375} cy={12.023} r={2.625} />
      <circle cx={20.625} cy={12.023} r={2.625} />
      <circle cx={12} cy={12.023} r={2.625} />
    </svg>
  );
}
export default SvgNavigationMenuHorizontal;
